var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.userInfo.avatar;
  },
  name: function name(state) {
    return state.user.userInfo.real_name;
  },
  uid: function uid(state) {
    return state.user.userInfo.uid;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  permissions: function permissions(state) {
    return state.user.permissions;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  menuList: function menuList(state) {
    return state.user.menuList;
  },
  isLogin: function isLogin(state) {
    return state.user.isLogin;
  },
  lang: function lang(state) {
    return state.app.language;
  },
  sidebarType: function sidebarType(state) {
    return state.app.sidebarType;
  },
  parentMenuId: function parentMenuId(state) {
    return state.app.parentMenuId;
  },
  sidebarParentCur: function sidebarParentCur(state) {
    return state.app.sidebarParentCur;
  },
  defaultOpen: function defaultOpen(state) {
    return state.app.defaultOpen;
  },
  isClickTab: function isClickTab(state) {
    return state.app.isClickTab;
  },
  menuStatus: function menuStatus(state) {
    return state.app.sidebar.opened;
  },
  enterprise: function enterprise(state) {
    return state.user.enterprise;
  },
  updatePromoter: function updatePromoter(state) {
    return state.business.updatePromoter;
  },
  processConditions: function processConditions(state) {
    return state.business.processConditions;
  },
  menuTabData: function menuTabData(state) {
    return state.app.menuTabData;
  },
  crudList: function crudList(state) {
    return state.app.crudList;
  }
};
export default getters;